@if ((products$ | async)?.products; as products) {
  @if (products && products.length > 0 && !(isLoader$ | async)) {
    <div class="col-md-12 p-0 float-left mt-3 pb-3 border-bottom d-flex align-items-center">
      @if (sorts$ | async; as sorts) {
        <div class="col-sm-12 col-md-3 col-lg-2 p-0 float-left">
          <cx-sorting
            [sortOptions]="sorts"
            [sortLabels]="getSortLabels() | async"
            (sortListEvent)="changeSortCode($event)"
            [selectedOption]="sortType"
            placeholder="{{ 'orderHistory.sortByMostRecent' | cxTranslate }}"
          ></cx-sorting>
        </div>
      }
      @if (paginate$ | async; as pagination) {
        <div class="col-sm-12 col-md-2 p-0 float-left text-center">
          <label>{{ pagination.totalResults }} {{ 'orderForms.label.productsFound' | cxTranslate }}</label>
        </div>
      }
    </div>
    <div class="col-md-12 p-0 float-left mt-3 d-flex align-items-center">
      @if (isOrderForm) {
        <div class="col-md-3 float-left">
          {{ 'orderForms.label.qtySelected' | cxTranslate }} {{ totalQty }}
        </div>
      }
      <div class="col-md-2">&nbsp;</div>
      @if (isOrderForm) {
        <div class="col-md-3 text-right">
          {{ 'orderForms.label.subTotal' | cxTranslate }} {{ subTotal | number: '1-2.2' }}
        </div>
      }
      @if (!isOrderForm) {
        <div class="col-md-10 p-0 float-left">
          <button
            (click)="createOrderForm()"
            [disabled]="checkedProducts && checkedProducts.length < 1"
            class="btn btn-primary col-md-3 float-right"
            >
            {{ 'orderForms.label.createOrderForm' | cxTranslate }}
          </button>
        </div>
      }
      @if (isOrderForm) {
        @if (cartContext || !quoteContext) {
          <kn-br-add-to-cart
            class="col-md-2 pr-0"
            [type]="'QUICK'"
            [productList]="selectedProducts"
            >
          </kn-br-add-to-cart>
        }
        @if (!cartContext || quoteContext) {
          <kn-br-add-to-quote
            class="col-md-2 pr-0"
            [type]="'QUICK'"
            [productList]="selectedProducts"
            >
          </kn-br-add-to-quote>
        }
      }
    </div>
    <div class="customersearch-list-table border-bottom mt-3 float-left col-lg-12 p-0 mb-3">
      <div class="customersearch-list-titles border-top float-left w-100 p-3 d-none d-sm-none d-lg-block">
        <div class="col-md-1 float-left font-text-600 font-size">&nbsp;</div>
        <div class="col-md-3 pl-0 float-left font-text-600 font-size">{{ 'orderForms.label.item' | cxTranslate }}</div>
        <div class="col-md-2 text-center float-left font-text-600 font-size">
          {{ 'orderForms.label.listPrice' | cxTranslate }}
        </div>
        @if (isOrderForm) {
          <div class="col-md-2 text-center float-left font-text-600 font-size">
            {{ 'orderForms.label.qty' | cxTranslate }}
          </div>
          <div class="col-md-2 text-center float-left font-text-600 font-size">
            {{ 'orderForms.label.minQty' | cxTranslate }}
          </div>
          <div class="col-md-2 text-center float-left font-text-600 font-size">
            {{ 'orderForms.label.total' | cxTranslate }}
          </div>
        }
        @if (!isOrderForm) {
          <div class="col-md-5 float-left text-center font-text-600 font-size">
            {{ 'orderForms.label.selectProduct' | cxTranslate }}
          </div>
        }
      </div>
      @if (products && products.length > 0) {
        @for (item of products; track item) {
          <kn-br-order-form-item
            [item]="item"
            [isOrderForm]="isOrderForm"
            (onChangeProduct)="onChangeProduct($event)"
            (quantityChange)="onQuantityChange($event)"
            >
          </kn-br-order-form-item>
        }
      }
    </div>
    <div class="col-md-12 p-0 float-left pb-3 border-bottom d-flex align-items-center">
      @if (isOrderForm) {
        <div class="col-md-3 float-left">
          {{ 'orderForms.label.qtySelected' | cxTranslate }} {{ totalQty }}
        </div>
      }
      <div class="col-md-2">&nbsp;</div>
      @if (isOrderForm) {
        <div class="col-md-3 text-right">
          {{ 'orderForms.label.subTotal' | cxTranslate }} {{ subTotal | number: '1-2.2' }}
        </div>
      }
      @if (!isOrderForm) {
        <div class="col-md-10 p-0 float-left">
          <button
            (click)="createOrderForm()"
            [disabled]="checkedProducts && checkedProducts.length < 1"
            class="btn btn-primary col-md-3 float-right"
            >
            {{ 'orderForms.label.createOrderForm' | cxTranslate }}
          </button>
        </div>
      }
      @if (isOrderForm) {
        @if (cartContext || !quoteContext) {
          <kn-br-add-to-cart
            class="col-md-2 pr-0"
            [type]="'QUICK'"
            [productList]="selectedProducts"
            >
          </kn-br-add-to-cart>
        }
        @if (!cartContext || quoteContext) {
          <kn-br-add-to-quote
            class="col-md-2 pr-0"
            [type]="'QUICK'"
            [productList]="selectedProducts"
            >
          </kn-br-add-to-quote>
        }
      }
    </div>
    <div class="col-md-12 p-0 float-left border-bottom d-flex align-items-center">
      @if (sorts$ | async; as sorts) {
        <div class="col-sm-12 col-md-3 col-lg-2 p-0 float-left">
          <cx-sorting
            [sortOptions]="sorts"
            [sortLabels]="getSortLabels() | async"
            (sortListEvent)="changeSortCode($event)"
            [selectedOption]="sortType"
            placeholder="{{ 'orderHistory.sortByMostRecent' | cxTranslate }}"
          ></cx-sorting>
        </div>
      }
      @if (paginate$ | async; as pagination) {
        <div class="col-sm-12 col-md-2 col-lg-2 p-0 float-left text-center">
          <label>{{ pagination.totalResults }} {{ 'orderForms.label.productsFound' | cxTranslate }}</label>
        </div>
        <div class="col-md-3 float-left">&nbsp;</div>
        <div class="col-md-4 col-sm-12 col-lg-5 p-0 float-left">
          @if (pagination.totalPages > 1) {
            <div class="col-lg-12 p-0 float-left mt-3 mb-3 d-flex justify-content-end">
              <cx-pagination [pagination]="pagination" (viewPageEvent)="onpageChange($event)"></cx-pagination>
            </div>
          }
        </div>
      }
    </div>
  }
  @if (products && products.length < 1 && !(isLoader$ | async)) {
    <div class="alert-info p-3 rounded mt-3">
      {{ 'orderForms.nodataMsg' | cxTranslate }}
    </div>
  }
}
@if (isLoader$ | async) {
  <div>
    <cx-spinner></cx-spinner>
  </div>
}
